import TableHead from "./Table/TableHead";

import useTable from "./Provider/useTable";
import TableRow from "./Table/TableRow";

import { Table, TBody } from "../components";

import { useNavigate } from "react-router-dom";
import TableContext from "./Provider/TableContext";
import ApproveModal from "./Table/ApproveModal";
import CancelModal from "./Table/CancelModal";
import DeleteModal from "./Table/DeleteModal";

function PurchaseOrders() {
  const {
    limit,
    setLimit,
    docs,
    setDocs,
    isLoading,
    setIsLoading,
    isFiltered,
    setIsFiltered,
    pagination,
    genders,
    dobRange,
    setDobRange,
    selectedGenders,
    setSelectedGenders,
    doaRange,
    setDoaRange,
    setOrder,
    clearFilters,
    refetchDocs,
    orderId,
    setOrderId,
    showApproveModal,
    setShowApproveModal,
    showCancelModal,
    setShowCancelModal,
    showDeleteModal,
    setShowDeleteModal,
    handleDelete,
    handleApprove,
    handleCancel,
  } = useTable();

  const navigate = useNavigate();

  return (
    <>
      <TableContext.Provider
        value={{
          limit,
          setLimit,
          docs,
          setDocs,
          isLoading,
          setIsLoading,
          isFiltered,
          setIsFiltered,
          pagination,
          genders,
          dobRange,
          setDobRange,
          selectedGenders,
          setSelectedGenders,
          doaRange,
          setDoaRange,
          setOrder,
          clearFilters,
          refetchDocs,
          orderId,
          setOrderId,
          showApproveModal,
          setShowApproveModal,
          showCancelModal,
          setShowCancelModal,
          showDeleteModal,
          setShowDeleteModal,
          handleDelete,
          handleApprove,
          handleCancel,
        }}
      >
        <Table
          label="Purchase Orders"
          isLoading={isLoading}
          setIsLoading={setIsLoading}
          setDocs={setDocs}
          isFiltered={isFiltered}
          handleAdd={() => navigate("add")}
          setIsFiltered={setIsFiltered}
          handleRemoveFilters={clearFilters}
          pagination={pagination}
          url="roles/search"
        >
          <TableHead setOrder={setOrder} />
          <TBody>
            {docs.map((doc, i) => {
              // console.log("doc", doc);
              return <TableRow key={doc?.id || i} doc={doc} />;
            })}
          </TBody>
        </Table>
      </TableContext.Provider>
      {showDeleteModal && (
        <DeleteModal
          showDeleteModal={showDeleteModal}
          setShowDeleteModal={setShowDeleteModal}
          handleDelete={handleDelete}
        />
      )}
      {showApproveModal && (
        <ApproveModal
          showApproveModal={showApproveModal}
          setShowApproveModal={setShowApproveModal}
          handleApprove={handleApprove}
        />
      )}
      {showCancelModal && (
        <CancelModal
          showCancelModal={showCancelModal}
          setShowCancelModal={setShowCancelModal}
          handleCancel={handleCancel}
        />
      )}
    </>
  );
}

export default PurchaseOrders;
